import FormErrorMessage from './FormErrorMessage';
import connectFormNode from '../../hoc/connectFormNode';

export default connectFormNode(FormErrorMessage);
